import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { greyMui, MOBILE_BREAKPOINT, rydeColors } from "@ryde/theme";

const TableRowEmptyStyled = styled.tr.attrs<IStyledAttributes>({
  "data-e2e": "table-row-empty",
})`
  td {
    border-inline-start: none;
    border-top: 1px solid ${greyMui._300};
    text-align: center;
    vertical-align: middle;
  }

  label {
    font-size: 14px;
    font-weight: 600;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    td.table_left_line {
      position: sticky;
      inset-inline-start: 0;
      width: 3px;
    }
    td.offset_mobile {
      position: sticky;
      inset-inline-start: 3px;
      background-color: ${rydeColors.white};
      min-width: 130px;
    }
    td.no_rows_area {
      position: sticky;
      inset-inline-start: 133px;
      width: calc(100% - 133px);
    }
  }
`;

const offsetColsDesktop = 3;

export const TableRowEmpty: FC<{ cells: number }> = ({ cells }) => {
  const { t } = useTranslation();
  const colSpan = useMemo(() => {
    if (!cells) {
      return 1;
    }

    return cells - offsetColsDesktop;
  }, [cells]);
  return (
    <TableRowEmptyStyled>
      <td className="table_left_line"></td>
      <td className="offset_mobile" colSpan={2}>
        <span></span>
      </td>
      <td className="no_rows_area" colSpan={colSpan}>
        <label>{t("general.NO_ROWS")}</label>
      </td>
    </TableRowEmptyStyled>
  );
};
